module.exports = __webpack_public_path__ + "img/jyusyoku_sasaki.f9ef9b20.png";